<template>
  <button @click='$emit("click")'>
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'Button',
    props: {
      click: {
        type: Function,
      }
    },
  }
</script>

<style lang="less" scoped>
button {
  height: 50px;
  min-width: 140px;
  padding-left: 15px;
  padding-right: 15px;
  background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
  border-radius: 25px;
  border: none;
  color: #fff;
  cursor: pointer;
  outline: none;
  font-size: 18px;
  &:hover {
    opacity: 0.9;
  }
}
</style>